import { Button, Stack, Text } from '@/theme/components';
import { styled } from '@/theme/index';

export const OwnerSearchTitle = styled(Text)(({ theme }) => ({
  alignSelf: 'baseline',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(2),
}));

export const OwnerSearchContainer = styled(Stack)(({ theme }) => ({
  alignItems: 'flex-start',
  flexDirection: 'row',
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    flexDirection: 'column',
  },
}));

export const OwnerSearchInputContainer = styled(Stack)(({ theme }) => ({
  width: '50%',
  marginRight: '8px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    marginRight: '0',
  },
}));

export const OwnerSearchButton = styled(Button)(({ theme }) => ({
  height: 'min-content',
  marginTop: '22px',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    marginTop: '16px',
  },
}));
